import React from "react";
import Image from "next/image";

import TeamHead from "./TeamHead";

import TeamData from "../../data/elements/team.json";

const TeamFour = ({ isHead }) => {
  return (
    <>
      <div className="container">
        {isHead ? (
          <TeamHead 
            title="Menfis talented team members" 
            desc="Nuestro equipo está compuesto por personas apasionadas y comprometidas. Nuestros docentes y profesores nativos, son profesionales capacitados que garantizan una educación de calidad, centrada en la formación humana y en valores. Cada miembro de Menfis contribuye con dedicación a crear un entorno seguro y enriquecedor para nuestros estudiantes"
          />
        ) : (
          ""
        )}

        <div className="row row--5 mt_dec--30 mb--30">
          {TeamData &&
            TeamData.team.map((data, index) => (
              <div className="col-lg-3 col-md-6 col-12 mt--30" key={index}>
                {data.details.map((item, innderIndex) => (
                  <div
                    className="rbt-team team-style-default style-three rbt-hover"
                    key={innderIndex}
                  >
                    <div className="inner">
                      <div className="thumbnail">
                        <Image
                          src={item.img}
                          width={190}
                          height={250}
                          priority
                          alt={`picture of ${item.name}`}
                        />
                      </div>
                      <div className="content">
                        <h2 className="title">{item.name}</h2>
                        <h4 className="subtitle theme-gradient">{item.type}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default TeamFour;
